import React from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import HeroHeading from 'components/hero-heading';
import { Offers } from 'components/offers-homepage-tims';
import Picture from 'components/picture';
import useEffectOnce from 'hooks/use-effect-once';
import { useFeatureLayout } from 'hooks/use-feature-layout';
import { useOffersContext } from 'state/offers';

import { IOffersPage } from './types';

const StyledHeroHeading = styled(HeroHeading)`
  padding: 2rem;

  ${Styles.desktop`
    text-align: center;
    padding: 10rem 0 0;
  `}
`;

const StyledOffers = styled(Offers)`
  padding: 2rem 0rem;
`;

/**
 * ov1uir
 * NOTE: Tim's does not actively use the Offers page
 *       This UI is only here internally for folks to
 *       trigger evaluateUserOffers query
 * @TODO: maybe figure out better system for internal
 *        use so that this can be removed entirely
 */
const OffersPage: React.FC<IOffersPage> = ({ className }) => {
  const { featureLayout } = useFeatureLayout();
  const { locale: defaultHeroImage } = featureLayout?.defaultHeroImage || {};
  const { formatMessage } = useIntl();
  const { loading, refreshOffers } = useOffersContext();

  /**
   * Reload offers/coupons if OffersContext isn't loading that right now
   */
  useEffectOnce(() => {
    !loading && refreshOffers();
  });

  return (
    <div className={className}>
      <Helmet title={formatMessage({ id: 'offers' })} />
      {defaultHeroImage && (
        <Picture image={defaultHeroImage} alt="Header Image">
          <StyledHeroHeading>{formatMessage({ id: 'offers' })}</StyledHeroHeading>
        </Picture>
      )}
      <StyledOffers />
    </div>
  );
};

export default OffersPage;
